"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServicesEmbedsTypeGroupSchema = void 0;
exports.ServicesEmbedsTypeGroupSchema = {
    "$id": "https://www.redbull.com/schemas/type-groups/services/embeds.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "ServicesEmbedsTypeGroup",
    "description": "ServicesEmbedsTypeGroup represents one of the following types: AcastPodcast, BracketsEmbed, CloudinaryImage, EventBriteCheckout, FacebookPost, Giphy, InstagramEmbed, JotForm, MediabaseDeliveryAgentClips, MediabaseDeliveryAgentClips, MediabaseDeliveryAgentClips, MegaphonePodcastEpisode, MixcloudAudio, ParticipantGallery, PixleeEmbed, RallyTvVideo1, RBMNLive, RBMNVideo, BrightcoveVRVideo, RedBullTVLinearStream, RedBullTVLiveVideostream, RedBullTVVideo, RiddleEmbed, RiddleEmbed, ServusTVLiveVideo, ServusTVVideo, SoundcloudAudio, SoundcloudAudio, Spotify, Spotify, SpreakerAudio, TikTokEmbed, TwitchLiveVideo, TwitchLiveVideo, TwitterTweetEmbed, TwitterFollow, VimeoVideo, VKVideo, WrcErcStandingsAndResults, YoutubePlaylist, YoutubeShort, YoutubeVideo, ZoeEmbed",
    "oneOf": [
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/acast-audio/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/brackets-embed/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/cloudinary-image/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/eventbrite/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/facebook-socialembed-post/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/giphy-videoclip/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/instagram-embed/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/jotform-forms/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/mediabase-delivery-agent-clip/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/mediabase-delivery-agent-clip/2.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/mediabase-delivery-agent-clip/3.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/megaphone-podcast-episode/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/mixcloud-audio/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/participant-gallery/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/pixlee-embed/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/rally-tv-video/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/rbmn-live/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/rbmn-video/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/redbull_com-vr-video/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/redbull_tv-linear-stream/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/redbull_tv-live/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/redbull_tv-video/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/riddle-embed/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/riddle-embed/2.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/servus-tv-livevideo/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/servus-tv-video/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/soundcloud-audio/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/soundcloud-audio/2.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/spotify-audio/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/spotify-audio/2.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/spreaker-audio/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/tiktok-embed/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/twitch-livevideo/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/twitch-livevideo/2.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/twitter-socialembed/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/twitter-sociallink/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/vimeo-video/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/vk-video/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/wrc-erc-standings-and-results/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/youtube-playlist/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/youtube-short/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/youtube-video/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/zoe-embed/1.schema.json"
        }
    ]
};
//# sourceMappingURL=data:application/json;base64,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